import { render, staticRenderFns } from "./FlowChart.vue?vue&type=template&id=97ffef4e&scoped=true&lang=pug"
import script from "./FlowChart.vue?vue&type=script&lang=js"
export * from "./FlowChart.vue?vue&type=script&lang=js"
import style0 from "./FlowChart.vue?vue&type=style&index=0&id=97ffef4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ffef4e",
  null
  
)

export default component.exports